import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Pushes the current JWT into an HttpOnly cookie so browser navigations (such as the Swagger UI)
 * can authenticate against the APIs without an Authorization header.
 */
@Injectable({ providedIn: 'root' })
export class BearerCookieService {
  private _http = inject(HttpClient);

  public clearBearerCookie(): Observable<void> {
    return this._http.delete<void>('/BearerCookie');
  }

  public setBearerAsCookie(bearer: string): Observable<void> {
    return this._http.post<void>('/BearerCookie', { bearer });
  }
}
